export default function scoring(tournament) {
  if (tournament.get("tournament_type") === "Survivor") {
    return "Survivor";
  }
  return tournament.get("bet_type");
}
